<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">
            {{pageTitle}}
          </h2>
        </v-row>

        <v-col class="pt-2 pb-4">
          <v-row>
            <v-btn
              v-model="goBtn"
              @click="backButton()"
              color="orange"
              class="white--text"
              >{{$t('button.back')}}</v-btn
            >
          </v-row>
        </v-col>

        <v-container class="custom-form px-5" style="max-height: none;">
          <v-row>
            <v-toolbar flat>
              <v-toolbar-title
                >{{$t('attendancesummarybystafffrom')}}
                <span class="blue--text">
                    {{ this.formData.getFromDate }}</span
                  >
                  {{$t('columns.to')}}
                  <span class="blue--text">
                    {{ this.formData.getUntilDate }}</span
                  >
              </v-toolbar-title>
              <v-spacer></v-spacer>

                <button type="button" class="export-icon-btn export-icon-pdf mr-2" @click="printPDF" title="Export PDF">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
              PDF
            </button>

              <button type="button" class="export-icon-btn export-icon-csv mr-2" @click="getCSV" title="Export CSV">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
              CSV
            </button>

              <div class="gv-search" style="align-self: center; margin-left: 8px;">
                <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
              </div>
          </v-toolbar>
        </v-row>

          <v-row class="mt-6">
            <v-col cols="12">
              <div style="overflow-x: auto; width: 100%;">
              <v-data-table
                :headers="dataHeader"
                :search="search"
                :items="dataItems"
                :items-per-page="10"
                class="font-weight-light;text--secondary;"
                :sort-by="['compnycode']"
                fixed-header
                no-data-text="No records found."
              >
              </v-data-table>
              </div>
            </v-col>
          </v-row>

       
        </v-container>
      </v-form>
   </v-container>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {

  components: {
    Loading,
  },

  data() {
    return {

      publicPath: process.env.BASE_URL,

      pageTitle: this.$t('attendancesummarybystaff'),

      formData: {
        getFromDate: this.$route.params.fromDate,
        getUntilDate: this.$route.params.untilDate,
        getCompanyId: this.$route.params.companyid,
      },

      dataHeader: [
        { text: this.$t('columns.staffno'), value: 'staffcode'},
        { text: this.$t('columns.name'), value: 'psnname'},
        { text: this.$t('setuptotal.totalworkhours'), value: "twh"},
        { text: this.$t('setuptotal.totalnormaldayothours'), value: "tnoth"},
        { text: this.$t('setuptotal.totaloffdayothours'), value: "toth"},
        { text: this.$t('setuptotal.totalrestdayothours'), value: "troth" },
        { text: this.$t('setuptotal.totalholidayothours'), value: "thoth" },
        { text: this.$t('setuptotal.totalothours'), value: "tothrs" },
        { text: this.$t('setuptotal.totalshiftallowance'), value: "tsa" },
        { text: this.$t('setuptotal.totalotallowance'), value: "tota" },
        { text: this.$t('setuptotal.totalabsentdays'), value: "tad" },
        { text: this.$t('columns.company'), value: "compnycode" },
      ],

      search: '',
      dataItems: [],

      goBtn: false,
      loading: false,

    };
  },

  methods: {
    backButton() {
      this.$router.push({ name: "attendancesummarybystafffilter" });
    },

    loadAttendanceSummaryByStaff(){
            
      const vm = this;

      vm.loading = true;

        this.$store.dispatch('post', {url: "/attendancesummary/all", payload: {param: vm.formData} })
         .then((res) => {

            vm.dataItems = res.data.rec;

            vm.loading = false;

          })
          .catch(function (err) {
               vm.errMsg = err;
          });

     },

    printPDF() {
       const doc = new jsPDF({
         orientation: "landscape",
       });

      var head = [
        { title: this.$t('columns.staffno'), dataKey: 'staffcode'},
        { title: this.$t('columns.name'), dataKey: 'psnname'},
        { title: this.$t('setuptotal.totalworkhours'), dataKey: "twh"},
        { title: this.$t('setuptotal.totalnormaldayothours'), dataKey: "tnoth"},
        { title: this.$t('setuptotal.totaloffdayothours'), dataKey: "toth"},
        { title: this.$t('setuptotal.totalrestdayothours'), dataKey: "troth" },
        { title: this.$t('setuptotal.totalholidayothours'), dataKey: "thoth" },
        { title: this.$t('setuptotal.totalothours'), dataKey: "tothrs" },
        { title: this.$t('setuptotal.totalshiftallowance'), dataKey: "tsa" },
        { title: this.$t('setuptotal.totalotallowance'), dataKey: "tota" },
        { title: this.$t('setuptotal.totalabsentdays'), dataKey: "tad" },
        { title: this.$t('columns.company'), dataKey: "compnycode" },
       ];

       let body = [];
        for (var i = 0; i < this.dataItems.length; i++) {
        body.push({
          staffcode: this.dataItems[i].staffcode,
          psnname: this.dataItems[i].psnname,
          twh : this.dataItems[i].twh,
          tnoth: this.dataItems[i].tnoth,
          toth: this.dataItems[i].toth,
          troth: this.dataItems[i].troth,
          thoth: this.dataItems[i].thoth,
          tothrs: this.dataItems[i].tothrs,
          tsa: this.dataItems[i].tsa,
          tota: this.dataItems[i].tota,
          tad: this.dataItems[i].tad,
          compnycode: this.dataItems[i].compnycode,
        });
      }
         doc.text(
        `Attendance Summary by Staff from ${this.formData.getFromDate} to ${this.formData.getUntilDate}`,
        10,
        10
      );
 
      doc.autoTable(head, body);
      doc.save("Attendance Summary by Staff.pdf");
    },

    objectToCSV(data) {
      const csvRows = [];

      // get header
      const headers = Object.keys(data[0]);
      csvRows.push(headers.join(","));

      // loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
      }
      return csvRows.join("\n");
    },

    download(data) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute(
        "download",
        "Attendance Summary by Staff.csv"
      );

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    async getCSV() {
      let item = this.dataItems;
      let data = [];

      for (var i = 0; i < item.length; i++) {
        data.push({
          [`${this.$t('columns.staffno')}`]: item[i].staffcode,
          [`${this.$t('columns.name')}`]: item[i].psnname,
          [`${this.$t('setuptotal.totalworkhours')}`]: item[i].twh,
          [`${this.$t('setuptotal.totalnormaldayothours')}`]: item[i].tnoth,
          [`${this.$t('setuptotal.totaloffdayothours')}`]: item[i].toth,
          [`${this.$t('setuptotal.totalrestdayothours')}`]: item[i].troth,
          [`${this.$t('setuptotal.totalholidayothours')}`]: item[i].thoth,
          [`${this.$t('setuptotal.totalothours')}`]: item[i].tothrs,
          [`${this.$t('setuptotal.totalshiftallowance')}`]: item[i].tsa,
          [`${this.$t('setuptotal.totalotallowance')}`]: item[i].tota,
          [`${this.$t('setuptotal.totalabsentdays')}`]: item[i].tad,
          [`${this.$t('columns.company')}`]: item[i].compnycode,
        });
      }

      const csvData = this.objectToCSV(data);
      this.download(csvData);
    },

 },


  mounted() {

    this.loadAttendanceSummaryByStaff();
  
  },

};
</script>

<style>
.dateTitle {
  font-size: 12px;
  color: #ffffff;
  height: 0px;
  background-color: orange;
  align-content: center;
  justify-content: center;
}

.scroller {
  height: 100%;
  width: 100%;
}
.gv-search { position: relative; display: inline-flex; align-items: center; }
.gv-search-icon { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.gv-search-input { padding: 5px 10px 5px 30px; border: 1.5px solid #E8EDF5; border-radius: 8px; font-size: 0.83rem; font-family: inherit; color: #1E293B; outline: none; width: 180px; background: #fff; }
.gv-search-input:focus { border-color: #4F6BFF; box-shadow: 0 0 0 3px rgba(79,107,255,0.10); }
.wrapped-header { white-space: normal !important; word-wrap: break-word; line-height: 1.2; padding-top: 6px !important; padding-bottom: 6px !important; vertical-align: middle; min-width: 80px; max-width: 80px; }
.wrapped-header > span { display: block; white-space: normal; word-break: break-word; }
</style>